// extracted by mini-css-extract-plugin
export default {"title":"wishlistList_title__duUOZ","noResult":"wishlistList_noResult__-3wP1"};